import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListDataCard(props) {
  const {
    children
  } = props;
  const {
    isMobile
  } = useIsMobile(640);
  const listDataCardClasses = classNames({
    [moduleStyles['sib-list__data-card']]: true,
    [moduleStyles['sib-list__data-card-xs']]: isMobile
  });
  return /*#__PURE__*/React.createElement("div", {
    className: listDataCardClasses
  }, children);
}
ListDataCard.propTypes = {
  children: PropTypes.node.isRequired
};
export default ListDataCard;